import { useTranslation } from 'react-i18next'
import React from 'react'

import TabsMenu from '../../../packages/kiti/components/tabs/TabsMenu'

export const VIEWS = { LIST: 'list', KANBAN: 'kanban' }

// Same tab-switch pattern used by `processes/shared/TabMenuBar` to flip between
// Kanban/List/Dashboard for Service Orders — here it drives local state instead of
// separate routes, since both views share the same `/availability` page and data.
const ViewToggle = ({ view, setView }) => {
  const { t } = useTranslation('availability')

  const options = [
    { name: VIEWS.LIST, label: t('list'), active: view === VIEWS.LIST, onClick: () => setView(VIEWS.LIST) },
    { name: VIEWS.KANBAN, label: t('kanban'), active: view === VIEWS.KANBAN, onClick: () => setView(VIEWS.KANBAN) }
  ]

  return <TabsMenu justify="flex-start" options={options} />
}

export default ViewToggle
